<template>
  <v-row>
    <v-col
      v-if="!isLoading"
      cols="12"
    >
      <app-card-code :title="`${$t('menu.gestion')} / ${$t('menu.comitions')}`">
        <v-row class="ml-5 mr-5">
          <v-col cols="12">
            <Form />
          </v-col>
        </v-row>
      </app-card-code>
    </v-col>
  </v-row>
</template>

<script>
// eslint-disable-next-line import/no-unresolved
import AppCardCode from '@/@core/components/app-card-code/AppCardCode.vue'

import Form from './form/Form.vue'

export default {
  components: {
    AppCardCode,
    Form,
  },
  data() {
    return {
      isLoading: true,
      user: {},
    }
  },
  mounted() {
    this.profile()
  },
  methods: {
    profile() {
      this.axios
        .get(`${process.env.VUE_APP_API_URL}profile`, {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem('sanctum_auth')}`,
          },
        })
        .then(response => {
          // eslint-disable-next-line no-empty
          if (response.data.success === false) {
          }
          this.user = response.data.data
        })
        .catch(error => console.log(error))
        // eslint-disable-next-line no-return-assign
        .finally(() => {
          this.isLoading = false

          // this.isLoading = false
        })
    },
  },
}
</script>
